import React from 'react';
import img1 from '../../images/page-about-us/empleyee_growth.jpg';
import img2 from '../../images/page-about-us/empleyee_satisfaction.jpg';
import img3 from '../../images/page-about-us/gender_pay_gap.jpg';

function Employee() {
  return (
    <div className="employee">
      <img src={img1} alt="employee" />
      <img src={img2} alt="employee" />
      <img style={{paddingTop: "6px"}} src={img3} alt="employee"/>
    </div>
  );
}

export default Employee;
